/* Mega menu hover JS — handles hover-based mega menu with keyboard accessibility */
(function () {
  function initMegaMenu() {
    var megaMenus = document.querySelectorAll('.mega-menu');
    if (!megaMenus.length) return;

    megaMenus.forEach(function (menu) {
      var triggers = menu.querySelectorAll('.mega-menu__link[aria-expanded]');
      triggers.forEach(function (trigger) {
        trigger.addEventListener('mouseenter', function () {
          trigger.setAttribute('aria-expanded', 'true');
        });
        trigger.addEventListener('mouseleave', function () {
          trigger.setAttribute('aria-expanded', 'false');
        });
        trigger.addEventListener('focus', function () {
          trigger.setAttribute('aria-expanded', 'true');
        });
        trigger.addEventListener('blur', function () {
          trigger.setAttribute('aria-expanded', 'false');
        });
      });

      // Close when clicking outside
      document.addEventListener('click', function (e) {
        if (!menu.contains(e.target)) {
          triggers.forEach(function (t) {
            t.setAttribute('aria-expanded', 'false');
          });
        }
      });
    });
  }

  if (document.readyState !== 'loading') {
    initMegaMenu();
  } else {
    document.addEventListener('DOMContentLoaded', initMegaMenu);
  }
})();